import { NgModule } from '@angular/core';
import { SpeedReadingHeaderModule } from '@games/speed-reading/shared/speed-reading-header/speed-reading-header.module';
import { SpeedReadingFooterModule } from '@games/speed-reading/shared/speed-reading-footer/speed-reading-footer.module';
import { SpeedReadingResultModule } from '@games/speed-reading/shared/speed-reading-result/speed-reading-result.module';
import { TextsQuizComponent } from '@games/speed-reading/shared/texts-quiz/texts-quiz.component';
import { TextContainerComponent } from './../speed-reading/shared/text-container/text-container.component';
import { GamesSharedModule } from './games-shared.module';

@NgModule({
  imports: [
    GamesSharedModule,
    TextContainerComponent,
    SpeedReadingResultModule,
    SpeedReadingHeaderModule,
    SpeedReadingFooterModule,
    TextsQuizComponent,
  ],
  exports: [
    GamesSharedModule,
    TextContainerComponent,
    SpeedReadingResultModule,
    SpeedReadingHeaderModule,
    SpeedReadingFooterModule,
    TextsQuizComponent,
  ],
})
export class TextGamesSharedModule {}
